import { UserContext } from 'core/userContext';
import styled from 'styled-components';
import { AVATAR_SIZES, Avatar } from 'ui/avatar';
import { Truncate } from 'ui/utility/truncate';
import { colors, spacing } from 'ui/theme';

const TrucateName = styled(Truncate)`
  padding-right: ${spacing.eighth};
  line-height: 1.2;
  color: ${colors.textPrimary};

  [data-active='true'] & {
    color: inherit;
  }

  @media (max-width: 639px) {
    display: none;
  }
`;

export const ProfileAvatar = ({ userContext }: { userContext: Partial<UserContext> }) => {
  const { firstName, lastName, avatarUrl, project } = userContext;

  return (
    <>
      <Avatar
        firstName={firstName || ''}
        lastName={lastName}
        imgSrc={avatarUrl || ''}
        size={AVATAR_SIZES.MEDIUM}
      />
      <TrucateName maxWidth={140}>{project?.name}</TrucateName>
    </>
  );
};
